import classNames from "classnames"
import ApplicationComponent from "legacy/ApplicationComponent"
import { isset } from "legacy/helpers.es6"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

// Note: The following globals are loaded from external scripts and not imported:
// - $ (jQuery): Used for AJAX requests
// - Amplitude: Used for analytics tracking

class PromoCode extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      opened: false,
      promoCodeValidationError: "",
      focusOnce: false,
    }
    this.validator = validatorFactory()
    this.setOpened = this.setOpened.bind(this)
    this.setClosed = this.setClosed.bind(this)
    this.toggleView = this.toggleView.bind(this)
    this.validateCode = this.validateCode.bind(this)
    this.handleAmplitude = this.handleAmplitude.bind(this)
    this.buildCouponCodePressedAmplitudeProps =
      this.buildCouponCodePressedAmplitudeProps.bind(this)
    this.promoCode = null
    this.setPromoCodeRef = (element) => {
      this.promoCode = element
    }
  }

  componentDidMount() {
    if (
      !isset(this.props.promoCode) &&
      this.state.opened === true &&
      this.state.focusOnce !== true
    ) {
      this.promoCode.focus()
      this.setState({ focusOnce: true })
    }
  }

  setOpened() {
    this.setState({ opened: true })
    if (this.props.experienceName) {
      this.handleAmplitude(
        `${this.props.experienceName}:coupon_referral_code_link_pressed`,
        {
          marina_id: this.props.marina?.mcomId,
          marina_name: this.props.marina?.name,
          experience_name: this.props.experienceName,
        }
      )
    }
  }

  setClosed() {
    this.setState({ opened: false })
  }

  buildCouponCodePressedAmplitudeProps() {
    return {
      marina_id: this.props.marina?.mcomId,
      marina_name: this.props.marina?.name,
      coupon_referral_code: this.promoCode.value,
      experience_name: this.props.experienceName,
    }
  }

  validateCode() {
    const postObject = {
      email: this.props.email,
      promo_code: this.promoCode.value,
      marina_slug: this.props.marinaSlug,
    }
    if (this.props.userId) {
      postObject.user_id = this.props.userId
    }
    if (this.props.experienceName) {
      const amplitudeEvent = `${this.props.experienceName}:add_coupon_referral_code_pressed`
      const amplitudeProps = this.buildCouponCodePressedAmplitudeProps()
      this.handleAmplitude(amplitudeEvent, amplitudeProps)
    }

    $.post(
      process.env.API_BASE_URL + "/api/1.0/validate/promo_code",
      postObject,
      (data) => {
        this.setState({ promoCodeValidationError: "" })
        this.setClosed()
        this.props.setGlobalState({ promoCode: data }, this.props.reloadPricing)
      }
    ).fail((data) => {
      this.setState({ promoCodeValidationError: data.responseJSON.error })
    })
  }

  removeCode(code) {
    const update = {}
    update[code] = ""
    this.props.setGlobalState(update)
    this.setState({ promoCodeValidationError: "" }, this.props.reloadPricing)
  }

  addedCodes() {
    return (
      <div>
        {this.props.promoCode && (
          <div className="promo-code-item mb-0.5" key="promo_code">
            <div>
              <label>Coupon Code</label>
            </div>
            <div>
              <span className="promo-code-name">
                {this.props.promoCode.discount_text}
              </span>
              <button
                type="button"
                className="bg-transparent"
                aria-label="remove"
                onClick={() => this.removeCode("promoCode")}
              >
                <i className="icon icon-times p-1 text-red-600" />
              </button>
            </div>
          </div>
        )}
      </div>
    )
  }

  toggleView() {
    if (this.state.opened === false) {
      return (
        <button
          type="button"
          className="bg-transparent p-0 font-semibold text-blue-800 no-underline hover:text-blue-700"
          onClick={this.setOpened}
        >
          Have a coupon code?
        </button>
      )
    } else {
      return (
        <div className="form-group">
          <label htmlFor="promoCode">New Coupon Code</label>
          <div className="input-group form-control-with-icon">
            <i className="icon icon-coupon form-control-icon-left" />
            <input
              className="form-control"
              type="text"
              id="promoCode"
              ref={this.setPromoCodeRef}
            />
            <span className="input-group-btn">
              <button
                className="btn btn-primary promo-code-verify-btn border-0"
                type="submit"
                onClick={this.validateCode}
              >
                Apply
              </button>
            </span>
          </div>
          {this.validator.messageWhenPresent(
            this.state.promoCodeValidationError
          )}
        </div>
      )
    }
  }

  handleAmplitude(event, eventProps) {
    Amplitude.trackEvent(event, eventProps)
  }

  render() {
    const { useDockwaPlusPricing } = this.props
    this.validator.showMessages()
    return (
      <div
        id="promoCodeContainer"
        className={classNames("promo-code-wrapper", {
          "m-0": useDockwaPlusPricing,
        })}
      >
        {this.addedCodes()}
        {this.toggleView()}
      </div>
    )
  }
}

PromoCode.propTypes = {
  setGlobalState: PropTypes.func.isRequired,
  reloadPricing: PropTypes.func.isRequired,
  promoCode: PropTypes.shape({
    discount_text: PropTypes.string,
  }),
  referralCode: PropTypes.object,
  email: PropTypes.string,
  userId: PropTypes.number,
  marinaSlug: PropTypes.string,
  useDockwaPlusPricing: PropTypes.bool,
  experienceName: PropTypes.string,
  marina: PropTypes.shape({
    mcomId: PropTypes.string,
    name: PropTypes.string,
  }),
}

export default PromoCode
